<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">DISPUTE RESOLUTION</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">DISPUTE RESOLUTION</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Alert Messages -->
            <div class="row" v-if="alert.success || alert.failed || alert.info">
              <div class="col-12">
                <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                  <strong>Success!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.success = false"></button>
                </div>
                <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                  <strong>Error!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.failed = false"></button>
                </div>
                <div v-if="alert.info" class="alert alert-info alert-dismissible fade show" role="alert">
                  <strong>Info!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.info = false"></button>
                </div>
              </div>
            </div>

            <!-- Statistics Cards -->
            <div class="row mb-4">
              <div class="col-md-3">
                <div class="card border-start border-5 border-primary">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h3 class="text-primary mb-1">{{ statistics.total }}</h3>
                        <p class="text-muted mb-0">Total Disputes</p>
                      </div>
                      <div class="align-self-center">
                        <i class="mdi mdi-alert-circle-outline text-primary fs-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card border-start border-5 border-warning">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h3 class="text-warning mb-1">{{ statistics.pending }}</h3>
                        <p class="text-muted mb-0">Pending Review</p>
                      </div>
                      <div class="align-self-center">
                        <i class="mdi mdi-clock-outline text-warning fs-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card border-start border-5 border-success">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h3 class="text-success mb-1">{{ statistics.resolved }}</h3>
                        <p class="text-muted mb-0">Resolved</p>
                      </div>
                      <div class="align-self-center">
                        <i class="mdi mdi-check-circle-outline text-success fs-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card border-start border-5 border-danger">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h3 class="text-danger mb-1">{{ statistics.rejected }}</h3>
                        <p class="text-muted mb-0">Rejected</p>
                      </div>
                      <div class="align-self-center">
                        <i class="mdi mdi-close-circle-outline text-danger fs-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main content -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <!-- Header -->
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">Billing & Payment Disputes</h4>
                      <div>
                        <button v-if="getRight('RAISE DISPUTE')"
                                class="btn btn-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#raiseDisputeModal">
                          <i class="mdi mdi-plus-circle-outline font-size-16"></i>
                          <span class="d-md-inline ms-1">Raise Dispute</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-center">
                      <!-- Status Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Status:</label>
                        <select @change="filterByStatus($event)" class="form-select">
                          <option value="">All Status</option>
                          <option value="PENDING">Pending</option>
                          <option value="UNDER_REVIEW">Under Review</option>
                          <option value="RESOLVED">Resolved</option>
                          <option value="REJECTED">Rejected</option>
                          <option value="ESCALATED">Escalated</option>
                        </select>
                      </div>

                      <!-- Dispute Type Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Dispute Type:</label>
                        <select @change="filterByType($event)" class="form-select">
                          <option value="">All Types</option>
                          <option value="BILLING_ERROR">Billing Error</option>
                          <option value="PAYMENT_NOT_REFLECTED">Payment Not Reflected</option>
                          <option value="OVERCHARGE">Overcharge</option>
                          <option value="DUPLICATE_CHARGE">Duplicate Charge</option>
                          <option value="REFUND_REQUEST">Refund Request</option>
                          <option value="OTHER">Other</option>
                        </select>
                      </div>

                      <!-- Priority Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Priority:</label>
                        <select @change="filterByPriority($event)" class="form-select">
                          <option value="">All Priorities</option>
                          <option value="LOW">Low</option>
                          <option value="MEDIUM">Medium</option>
                          <option value="HIGH">High</option>
                          <option value="URGENT">Urgent</option>
                        </select>
                      </div>

                      <!-- Date Filters -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">From:</label>
                        <input v-model="dateFrom" class="form-control" type="date">
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">To:</label>
                        <input v-model="dateTo" class="form-control" type="date">
                      </div>

                      <!-- Search -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control" placeholder="Search...">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>
                    </div>

                    <!-- Download Button -->
                    <div class="mt-3">
                      <button v-if="getRight('DOWNLOAD REPORTS')" @click="downloadReport()"
                              type="button" class="btn btn-success">
                        <i class="bx bxs-download font-size-16"></i>
                        <span class="ms-1">{{ download }}</span>
                      </button>
                    </div>
                  </div>

                  <!-- Table -->
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th class="text-nowrap">NO.</th>
                          <th class="text-nowrap">Dispute ID</th>
                          <th class="text-nowrap">Bill/Receipt No</th>
                          <th class="text-nowrap">Customer</th>
                          <th class="text-nowrap">Type</th>
                          <th class="text-nowrap">Priority</th>
                          <th class="text-nowrap text-end">Amount</th>
                          <th class="text-nowrap">Status</th>
                          <th class="text-nowrap">Raised On</th>
                          <th class="text-nowrap">Assigned To</th>
                          <th class="text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in disputeDetails" :key="index">
                          <td class="text-nowrap">{{ index + 1 }}</td>
                          <td class="text-nowrap">
                            <strong class="text-primary">{{ item.disputeId }}</strong>
                          </td>
                          <td class="text-nowrap">{{ item.referenceNo }}</td>
                          <td class="text-nowrap">
                            <div>
                              <strong>{{ item.customerName }}</strong>
                              <small class="text-muted d-block">{{ maskPhoneNumber(item.customerPhone) }}</small>
                            </div>
                          </td>
                          <td class="text-nowrap">
                            <span class="badge bg-info">{{ formatDisputeType(item.disputeType) }}</span>
                          </td>
                          <td class="text-nowrap">
                            <span class="badge" :class="getPriorityClass(item.priority)">{{ item.priority }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.disputeAmount) }}</span>
                          </td>
                          <td class="text-nowrap">
                            <span class="badge" :class="getStatusClass(item.status)">{{ formatStatus(item.status) }}</span>
                          </td>
                          <td class="text-nowrap">{{ item.dateRaised }}</td>
                          <td class="text-nowrap">{{ item.assignedTo || 'Unassigned' }}</td>
                          <td class="text-nowrap">
                            <div class="d-flex">
                              <button @click="viewDispute(item)"
                                      class="btn btn-primary btn-sm me-2"
                                      data-bs-toggle="modal"
                                      data-bs-target="#disputeDetailModal">
                                View
                              </button>
                              <div class="dropdown">
                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle"
                                        data-bs-toggle="dropdown">
                                  <i class="bx bx-dots-vertical"></i>
                                </button>
                                <ul class="dropdown-menu">
                                  <li v-if="item.status === 'PENDING'">
                                    <a class="dropdown-item" @click="assignDispute(item)">
                                      <i class="mdi mdi-account-plus me-2"></i>Assign
                                    </a>
                                  </li>
                                  <li v-if="item.status !== 'RESOLVED' && item.status !== 'REJECTED'">
                                    <a class="dropdown-item" @click="updateStatus(item, 'UNDER_REVIEW')">
                                      <i class="mdi mdi-eye me-2"></i>Mark Under Review
                                    </a>
                                  </li>
                                  <li v-if="item.status !== 'RESOLVED' && item.status !== 'REJECTED'">
                                    <a class="dropdown-item" @click="resolveDispute(item)">
                                      <i class="mdi mdi-check me-2"></i>Resolve
                                    </a>
                                  </li>
                                  <li v-if="item.status !== 'RESOLVED' && item.status !== 'REJECTED'">
                                    <a class="dropdown-item" @click="rejectDispute(item)">
                                      <i class="mdi mdi-close me-2"></i>Reject
                                    </a>
                                  </li>
                                  <li v-if="item.status === 'UNDER_REVIEW'">
                                    <a class="dropdown-item" @click="escalateDispute(item)">
                                      <i class="mdi mdi-arrow-up-bold me-2"></i>Escalate
                                    </a>
                                  </li>
                                  <li><hr class="dropdown-divider"></li>
                                  <li>
                                    <a class="dropdown-item" @click="addComment(item)">
                                      <i class="mdi mdi-comment-plus me-2"></i>Add Comment
                                    </a>
                                  </li>
                                  <li>
                                    <a class="dropdown-item" @click="sendNotification(item)">
                                      <i class="mdi mdi-bell me-2"></i>Notify Customer
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="text-center p-5">
                        <div class="spinner-border text-info mb-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <h4>Loading Data</h4>
                        <p>We are fetching the dispute data for you. Please wait...</p>
                      </div>

                      <!-- No Results -->
                      <div v-if="disputeDetails.length < 1 && !loading" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                        <h4>No Disputes Found</h4>
                        <p>No disputes match your current filter criteria.</p>
                      </div>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div class="card-footer bg-white">
                    <nav class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="me-3">Rows Per Page</span>
                        <select class="form-select w-auto" v-model="pageSize">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                        </select>
                      </div>

                      <ul class="pagination mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="prevPage" :disabled="currentPage === 1">Previous</button>
                        </li>
                        <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                            class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <button v-else class="page-link" @click="goToPage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Raise Dispute Modal -->
        <RaiseDisputeModal
            @dispute-raised="handleDisputeRaised"
        />

        <!-- Dispute Detail Modal -->
        <DisputeDetailModal
            :disputeDetail="selectedDispute"
            @status-updated="handleStatusUpdate"
            @comment-added="handleCommentAdded"
        />

        <!-- Assign Dispute Modal -->
        <AssignDisputeModal
            :disputeDetail="selectedDispute"
            :availableOfficers="availableOfficers"
            @dispute-assigned="handleDisputeAssigned"
        />

        <!-- Resolve Dispute Modal -->
        <ResolveDisputeModal
            :disputeDetail="selectedDispute"
            @dispute-resolved="handleDisputeResolved"
        />

        <!-- Reject Dispute Modal -->
        <RejectDisputeModal
            :disputeDetail="selectedDispute"
            @dispute-rejected="handleDisputeRejected"
        />

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, executeDownload, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";
import RaiseDisputeModal from "@/components/disputes/modals/RaiseDisputeModal.vue";
import DisputeDetailModal from "@/components/disputes/modals/DisputeDetailModal.vue";
import AssignDisputeModal from "@/components/disputes/modals/AssignDisputeModal.vue";
import ResolveDisputeModal from "@/components/disputes/modals/ResolveDisputeModal.vue";
import RejectDisputeModal from "@/components/disputes/modals/RejectDisputeModal.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "DisputeResolution",
  components: {
    NavigationBar,
    RaiseDisputeModal,
    DisputeDetailModal,
    AssignDisputeModal,
    ResolveDisputeModal,
    RejectDisputeModal
  },
  data() {
    return {
      download: 'Download Report',
      search: '',
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,

      // Filters
      dateFrom: '',
      dateTo: '',
      selectedStatus: '',
      selectedType: '',
      selectedPriority: '',

      // Data
      disputeDetails: [
        {
          disputeId: 'DSP-2025-001',
          referenceNo: 'SBP250001',
          customerName: 'John Doe Enterprises',
          customerPhone: '+254701234567',
          disputeType: 'BILLING_ERROR',
          priority: 'HIGH',
          disputeAmount: 15000,
          status: 'PENDING',
          dateRaised: '2025-01-15 10:30:00',
          assignedTo: null,
          description: 'Bill amount seems incorrect for my business category'
        },
        {
          disputeId: 'DSP-2025-002',
          referenceNo: 'RCT789456',
          customerName: 'Mary\'s Beauty Salon',
          customerPhone: '+254702345678',
          disputeType: 'PAYMENT_NOT_REFLECTED',
          priority: 'URGENT',
          disputeAmount: 12000,
          status: 'UNDER_REVIEW',
          dateRaised: '2025-01-14 14:20:00',
          assignedTo: 'Alice Wanjiku',
          description: 'Payment made via M-Pesa but not reflecting in system'
        },
        {
          disputeId: 'DSP-2025-003',
          referenceNo: 'SBP250003',
          customerName: 'Tech Solutions Ltd',
          customerPhone: '+254703456789',
          disputeType: 'OVERCHARGE',
          priority: 'MEDIUM',
          disputeAmount: 25000,
          status: 'RESOLVED',
          dateRaised: '2025-01-13 09:15:00',
          assignedTo: 'James Mwangi',
          description: 'Charged for category A instead of category C business'
        },
        {
          disputeId: 'DSP-2025-004',
          referenceNo: 'LR456789',
          customerName: 'Green Valley Restaurant',
          customerPhone: '+254704567890',
          disputeType: 'DUPLICATE_CHARGE',
          priority: 'HIGH',
          disputeAmount: 18000,
          status: 'REJECTED',
          dateRaised: '2025-01-12 16:45:00',
          assignedTo: 'Peter Kimani',
          description: 'Charged twice for the same land rates'
        },
        {
          disputeId: 'DSP-2025-005',
          referenceNo: 'SBP250005',
          customerName: 'City Hardware Store',
          customerPhone: '+254705678901',
          disputeType: 'REFUND_REQUEST',
          priority: 'LOW',
          disputeAmount: 22000,
          status: 'ESCALATED',
          dateRaised: '2025-01-11 11:30:00',
          assignedTo: 'Sarah Njeri',
          description: 'Business closed, requesting refund for SBP fee'
        }
      ],

      selectedDispute: {},

      availableOfficers: [
        { id: 1, name: 'Alice Wanjiku', department: 'Revenue' },
        { id: 2, name: 'James Mwangi', department: 'Finance' },
        { id: 3, name: 'Peter Kimani', department: 'Customer Service' },
        { id: 4, name: 'Sarah Njeri', department: 'IT Support' },
        { id: 5, name: 'David Ochieng', department: 'Legal' }
      ],

      statistics: {
        total: 156,
        pending: 23,
        resolved: 98,
        rejected: 15
      },

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    }
  },
  computed: {
    // Add computed properties for filtering if needed
  },
  watch: {
    pageSize() {
      this.getDisputesPaginate();
      this.totalPages = Math.ceil(this.disputeDetails.length / this.pageSize);
      this.currentPage = 1;
    },
    search() {
      this.getDisputesPaginate();
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.getDisputesPaginate();
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.getDisputesPaginate();
      }
    }
  },
  mounted() {
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');

    this.getDisputesPaginate();
    this.totalPages = Math.ceil(this.disputeDetails.length / this.pageSize);
    this.menuAccess();
  },
  methods: {
    getRight,

    // Utility methods
    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value);
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    formatDisputeType(type) {
      const types = {
        'BILLING_ERROR': 'Billing Error',
        'PAYMENT_NOT_REFLECTED': 'Payment Not Reflected',
        'OVERCHARGE': 'Overcharge',
        'DUPLICATE_CHARGE': 'Duplicate Charge',
        'REFUND_REQUEST': 'Refund Request',
        'OTHER': 'Other'
      };
      return types[type] || type;
    },

    formatStatus(status) {
      const statuses = {
        'PENDING': 'Pending',
        'UNDER_REVIEW': 'Under Review',
        'RESOLVED': 'Resolved',
        'REJECTED': 'Rejected',
        'ESCALATED': 'Escalated'
      };
      return statuses[status] || status;
    },

    getStatusClass(status) {
      switch (status) {
        case 'PENDING':
          return 'bg-warning';
        case 'UNDER_REVIEW':
          return 'bg-info';
        case 'RESOLVED':
          return 'bg-success';
        case 'REJECTED':
          return 'bg-danger';
        case 'ESCALATED':
          return 'bg-dark';
        default:
          return 'bg-secondary';
      }
    },

    getPriorityClass(priority) {
      switch (priority) {
        case 'LOW':
          return 'bg-light text-dark';
        case 'MEDIUM':
          return 'bg-info';
        case 'HIGH':
          return 'bg-warning';
        case 'URGENT':
          return 'bg-danger';
        default:
          return 'bg-secondary';
      }
    },

    gotTo(route) {
      router.push(route);
    },

    // Filter methods
    filterByStatus(event) {
      this.selectedStatus = event.target.value;
      this.getDisputesPaginate();
    },

    filterByType(event) {
      this.selectedType = event.target.value;
      this.getDisputesPaginate();
    },

    filterByPriority(event) {
      this.selectedPriority = event.target.value;
      this.getDisputesPaginate();
    },

    // API methods (using mock data for now)
    async getDisputesPaginate() {
      try {
        this.loading = true;

        // Simulate API call delay
        await new Promise(resolve => setTimeout(resolve, 500));

        // In real implementation, this would make an API call
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.message = e.message;
        this.alert.failed = true;
      }
    },

    async downloadReport() {
      try {
        this.download = "Please wait...";

        // Simulate download delay
        await new Promise(resolve => setTimeout(resolve, 2000));

        this.download = "Download Report";
        this.message = "Report downloaded successfully";
        this.alert.success = true;
      } catch (e) {
        this.download = "Download Report";
        this.message = e.message;
        this.alert.failed = true;
      }
    },

    // Dispute management methods
    viewDispute(dispute) {
      this.selectedDispute = dispute;
    },

    assignDispute(dispute) {
      this.selectedDispute = dispute;
      const modalElement = document.getElementById('assignDisputeModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    updateStatus(dispute, status) {
      dispute.status = status;
      this.message = `Dispute ${dispute.disputeId} status updated to ${this.formatStatus(status)}`;
      this.alert.success = true;
    },

    resolveDispute(dispute) {
      this.selectedDispute = dispute;
      const modalElement = document.getElementById('resolveDisputeModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    rejectDispute(dispute) {
      this.selectedDispute = dispute;
      const modalElement = document.getElementById('rejectDisputeModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    escalateDispute(dispute) {
      dispute.status = 'ESCALATED';
      this.message = `Dispute ${dispute.disputeId} has been escalated`;
      this.alert.info = true;
    },

    addComment(dispute) {
      // In real implementation, this would open a comment modal
      this.message = `Comment functionality for ${dispute.disputeId} would open here`;
      this.alert.info = true;
    },

    sendNotification(dispute) {
      this.message = `Notification sent to ${dispute.customerName}`;
      this.alert.success = true;
    },

    // Event handlers
    handleDisputeRaised(disputeData) {
      // Add new dispute to the list
      const newDispute = {
        disputeId: `DSP-2025-${String(this.disputeDetails.length + 1).padStart(3, '0')}`,
        ...disputeData,
        status: 'PENDING',
        dateRaised: moment().format('YYYY-MM-DD HH:mm:ss'),
        assignedTo: null
      };

      this.disputeDetails.unshift(newDispute);
      this.statistics.total++;
      this.statistics.pending++;

      this.message = "Dispute raised successfully";
      this.alert.success = true;
    },

    handleStatusUpdate(disputeId, newStatus) {
      const dispute = this.disputeDetails.find(d => d.disputeId === disputeId);
      if (dispute) {
        dispute.status = newStatus;
        this.message = `Dispute status updated successfully`;
        this.alert.success = true;
      }
    },

    handleCommentAdded(disputeId, comment) {
      this.message = "Comment added successfully";
      this.alert.success = true;
    },

    handleDisputeAssigned(disputeId, officerName) {
      const dispute = this.disputeDetails.find(d => d.disputeId === disputeId);
      if (dispute) {
        dispute.assignedTo = officerName;
        this.message = `Dispute assigned to ${officerName}`;
        this.alert.success = true;
      }
    },

    handleDisputeResolved(disputeId, resolution) {
      const dispute = this.disputeDetails.find(d => d.disputeId === disputeId);
      if (dispute) {
        dispute.status = 'RESOLVED';
        this.statistics.resolved++;
        this.statistics.pending--;
        this.message = "Dispute resolved successfully";
        this.alert.success = true;
      }
    },

    handleDisputeRejected(disputeId, reason) {
      const dispute = this.disputeDetails.find(d => d.disputeId === disputeId);
      if (dispute) {
        dispute.status = 'REJECTED';
        this.statistics.rejected++;
        this.statistics.pending--;
        this.message = "Dispute rejected";
        this.alert.info = true;
      }
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Dispute Resolution");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    },

    // Pagination methods
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getDisputesPaginate();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getDisputesPaginate();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getDisputesPaginate();
      }
    }
  }
}
</script>

<style scoped>
.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.card-header {
  padding: 1rem;
}

.spinner-border-sm {
  width: 0.875rem;
  height: 0.875rem;
}

.border-start {
  border-left-width: 5px !important;
}

.fs-1 {
  font-size: 2rem !important;
}
</style>